import { FC, memo } from 'react'
import { Button } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'
import Tooltip from '@mui/material/Tooltip'

const AddTextButton: FC = () => {
  const { store, saving } = usePdfEditor()
  const handleAddTextClicked = useCallbackDebounced(() => {
    store.activePage?.addElement({
      type: 'text',
      x: 50,
      y: 50,
      fill: 'black',
      text: '',
      align: 'left',
      placeholder: 'Please enter text here',
    })
  }, [store.activePage])
  return (
    <Tooltip title={'Add text'} placement="bottom">
      <Button intent="none" icon="font" onClick={handleAddTextClicked} disabled={saving} />
    </Tooltip>
  )
}

export default memo(AddTextButton)
